// extracted by mini-css-extract-plugin
module.exports = {"main":"RichText_main__3tapY"};